
const CountPages=(totalpages)=>{
    const totalPages = [];
    for(let i=1; i<=totalpages;i++){
        totalPages.push(i);
    }
    return totalPages;
}

export default CountPages;